module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message__pic"
  }), _c('div', {
    staticClass: "message__block"
  }, [_c('AppHeading', {
    attrs: {
      "level": "3",
      "mod": "bold"
    }
  }, [_vm._v("Заявка принята и будет обработана в ближайшее время.")]), _c('AppText', [_vm._v("На вашу электронную почту будет направлено письмо о подтверждении заявки. Уточнить статус заявки вы сможете в своем личном кабинете.")]), _c('Button', {
    attrs: {
      "short": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeMessage')
      }
    }
  }, [_vm._v("Закрыть")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd60aaf","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newprogram/components/message/Message.vue
// module id = 0b654757519f96fe44d9
// module chunks = 10